"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ChangeType;
(function (ChangeType) {
    ChangeType[ChangeType["Unknown"] = 0] = "Unknown";
    ChangeType[ChangeType["Add"] = 1] = "Add";
    ChangeType[ChangeType["Change"] = 2] = "Change";
    ChangeType[ChangeType["Delete"] = 3] = "Delete";
    ChangeType[ChangeType["Date"] = 4] = "Date";
    ChangeType[ChangeType["Status"] = 5] = "Status";
    ChangeType[ChangeType["Doctor"] = 6] = "Doctor";
    ChangeType[ChangeType["Annotation"] = 7] = "Annotation";
    ChangeType[ChangeType["PermanentExceedMaxAmount"] = 8] = "PermanentExceedMaxAmount";
    ChangeType[ChangeType["Day"] = 9] = "Day";
})(ChangeType = exports.ChangeType || (exports.ChangeType = {}));
exports.default = ChangeType;
